import { useEffect, useState } from "react";
import client from "@/api/client";

const STORAGE_KEY = "machine-type-filter";

export function useMachineTypeFilter() {
  const [machineType, setMachineTypeState] = useState(() => localStorage.getItem(STORAGE_KEY) || "");
  const setMachineType = (v) => {
    setMachineTypeState(v);
    if (v) localStorage.setItem(STORAGE_KEY, v);
    else localStorage.removeItem(STORAGE_KEY);
  };
  return [machineType, setMachineType];
}

export function MachineTypeFilter({ value, onChange, testId }) {
  const [types, setTypes] = useState([]);

  useEffect(() => {
    client
      .get("/assets/machine-types")
      .then((res) => setTypes(res.data))
      .catch(() => setTypes([]));
  }, []);

  const options = value && !types.some((t) => t.toLowerCase() === value.toLowerCase()) ? [value, ...types] : types;

  return (
    <select
      data-testid={testId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="h-9 w-48 rounded-md border border-input bg-transparent px-3 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
    >
      <option value="">All machine types</option>
      {options.map((t) => (
        <option key={t} value={t}>
          {t}
        </option>
      ))}
    </select>
  );
}
